import { AnimalEvent } from './animal-event';
import { DomainEntity } from '@homeleite/arch';

export class AnimalEventEntity implements AnimalEvent, DomainEntity {
    constructor(
        public id: string,
        public date: Date,
        public animal: any,
        public type: string,
        public created: Date,
        /** APP | SRG_SCL */
        public origin: string | null = null,
        public milkControlId: string | null = null
    ) {}

    static fromJson(json: any): AnimalEventEntity {
        return new AnimalEventEntity(
            json.id,
            new Date(json.date),
            json.animal,
            json.type,
            json.created ? new Date(json.created) : null,
            json.origin ?? null,
            json.milkControlId ?? null
        );
    }

    toJson(): any {
        return {
            id: this.id,
            date: this.date.toISOString(),
            animal: this.animal.toJson(),
            type: this.type,
            created: this.created?.toISOString() ?? null,
            origin: this.origin,
            milkControlId: this.milkControlId
        };
    }
}
